
import { ReactChart } from 'chartjs-react';
import { Chart, registerables } from 'chart.js';
import { useMemo, useState } from 'react';
import TenantServices from './../../services/TenantServices';
import { RefreshIcon } from '@heroicons/react/solid';
import { HollowDotsSpinner } from 'react-epic-spinners';
import { useCachedResource } from './../../utils/apiCache';
Chart.register(...registerables);

const buildOptions = (resp) => {
  var labels = [];
  var successfulData = [];
  var failedData = [];
  resp?.data?.map(data => {
    successfulData.push(data.successSum);
    failedData.push(data.failedSum);
    labels.push(data.date);
  });
  return {
    labels: [...labels],
    datasets: [{
      label: "Successful Transfer",
      data: [...successfulData],
      lineTension: 0,
      fill: false,
      borderColor: 'green',
      backgroundColor: 'transparent',
      pointBorderColor: 'green',
      pointBackgroundColor: 'green',
      borderDash: [15, 5],
      pointRadius: 5,
      pointHoverRadius: 10,
      pointHitRadius: 30,
      pointBorderWidth: 2,
      pointStyle: 'rectRounded'
    },
    {
      label: "Failed Transfer",
      data: [...failedData],
      lineTension: 0,
      fill: false,
      borderColor: 'red',
      backgroundColor: 'transparent',
      pointBorderColor: 'red',
      pointBackgroundColor: 'red',
      borderDash: [15, 5],
      pointRadius: 5,
      pointHoverRadius: 10,
      pointHitRadius: 30,
      pointBorderWidth: 2,
      pointStyle: 'rectRounded'
    }]
  };
};

export default function TransferGraph(){
  const [dataOpt, setDataOpt] = useState({
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          boxWidth: 10,
          usePointStyle: true,
          pointStyle: "line"
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        title: {
          display: true,
          text: "Transfer",
          color: "red",
          font: {
            size: 24,
            weight: "bold"
          }
        }
      },
      y: {
        grid: {
          color: "#ccc",
          borderDash: [5, 1],
          borderColor: "black",
          tickColor: "black"
        },
        title: {
          display: true,
          text: "",
          color: "green",
          font: {
            size: 18,
            weight: "bold"
          }
        }
      }
    }
  });

  const { data: resp, loading, refresh } = useCachedResource(
    "dashboard.transfers-graph",
    () => TenantServices.transferGraph()
  );

  const graphData = useMemo(() => (resp ? buildOptions(resp) : {}), [resp]);

  return (
    <div className="relative mt-5">
      <button
        type="button"
        onClick={refresh}
        className="absolute top-2 right-2 z-10 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-100 focus:outline-none"
      >
        <RefreshIcon className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
        Refresh
      </button>
      {loading && Object.keys(graphData).length === 0 ? (
        <div className="flex justify-center py-10">
          <HollowDotsSpinner size={40} color="#4D627E" />
        </div>
      ) : (
        <ReactChart
          type="line"
          data={graphData}
          options={dataOpt}
          width={100}
        />
      )}
    </div>
  );
}
